/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createV2Goal} from '../api'

export const useMutationCreateV2Goal = createReactQueryMutationHook('createV2Goal', createV2Goal)
